/**
 * Get the local date components from a UTC date
 * @param date
 * @returns {{year: number, month: number, day: number}}
 */
function getLocalDateComponents(date) {
  return {
    year: date.getFullYear(),
    month: date.getMonth(),
    day: date.getDate(),
  };
}

/**
 * Check if two UTC dates are the same local timezone day
 * @returns {boolean} - True if the dates are the same local day, false otherwise
 * @param {Date} day1
 * @param {Date} day2
 */
export default function checkSameLocalDay(day1, day2) {
  const {
    year: year1,
    month: month1,
    day: dayNum1,
  } = getLocalDateComponents(day1);
  const {
    year: year2,
    month: month2,
    day: dayNum2,
  } = getLocalDateComponents(day2);

  return (year1 === year2 && month1 === month2 && dayNum1 === dayNum2);
}
